<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="page-heading">
  <br>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/home"><em class="la la-home font-20"></em></a>
    </li>
    <li class="breadcrumb-item">
      <span i18n="@@payPalPaymentValidated">PayPal payment validated</span>
    </li>
  </ol>
</div>

<div class="page-content fade-in-up">
  <div class="ibox">
    <div class="ibox-head">
      <div class="ibox-title" i18n="@@payPalPaymentValidated">PayPal payment validated</div>
    </div>

    <div class="ibox-body">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
        <p i18n="@@payPalValidatedAccepted">Your payment have been accepted.</p>

        <p><u i18n="@@removalRequestInfoOutside">
          Thank you to provide the animal corpse, outside buildings, in a non-hazardous area (power line, phone, rough
          terrain ....).
        </u></p>

        <p i18n="@@payPalValidatedEmail">
          You will receive an email with your removal number once it is confirmed by PayPal.
        </p>
      </div>

      <app-display-go-home></app-display-go-home>

    </div>
  </div>
</div>
